export const agenda = [
    
    {
        'id': 1,
        'title': 'Instalación del Comité de Planeación para el Desarrollo Regional de la Región IX Zacualtipán.',
        'place': 'Zacualtipán de Ángeles',
        'start': '2023-04-19',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/PlaneacionHgo/status/1648789356071596033?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },

    {
        'id': 2,
        'title': 'Audiencia Pública en Zacualtipán de Ángeles con la participación de los secretarios del gobierno de Hidalgo.',
        'place': 'Zacualtipán de Ángeles',
        'start': '2023-04-19',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/planeacionhgo/status/1648819428891709440?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 3,
        'title': 'Gira de trabajo en el Municipio de Tlaxcoapan con el Presidente Municipal',
        'place': 'Tlaxcoapan',
        'start': '2023-04-20',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/planeacionhgo/status/1649203525983846405?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 4,
        'title': 'Gira de trabajo',
        'place': 'San Salvador',
        'start': '2023-04-21',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1649793879837753344?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 5,
        'title': 'Reunión de trabajo con la titular de la Secretaría de Hacienda Hidalgo.',
        'place': 'Pachuca de Soto',
        'start': '2023-04-25',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/esther_ramirezv/status/1650957591684747264?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 6,
        'title': 'Instalación del Comité de Planeación para el Desarrollo Regional',
        'place': 'Huejutla de Reyes',
        'start': '2023-04-26',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1651374469955420163?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 7,
        'title': 'Audiencia Pública',
        'place': 'Huejutla de Reyes',
        'start': '2023-04-26',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1651374469955420163?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },    
    {
        'id': 8,
        'title': 'Reunión mensual de gabinete. Presidida por el Gobernador del Estado, Julio Menchaca Salazar',
        'place': 'Zacualtipán de Ángeles',
        'start': '2023-05-05',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/PlaneacionHgo/status/1654606166989651975/photo/1"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 9,
        'title': 'Instalación del Comité de Planeación para el Desarrollo Regional de la región XI Huichapan',
        'place': 'Huichapan',
        'start': '2023-05-17',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/planeacionhgo/status/1658950725970345985?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 10,
        'title': 'Audiencia Pública en Huichapan',
        'place': 'Huichapan',
        'start': '2023-05-17',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="https://twitter.com/planeacionhgo/status/1658963750282510338?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 11,
        'title': 'Primera Sesión Ordinaria del Consejo de Desarrollo Metropolitano del Valle de México 2023. ',
        'place': 'Pachuca de Soto',
        'start': '2023-05-19',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1659679320623783938?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 12,
        'title': 'Reunión con titulares de dependencias estatales para definir planes, estrategias y resultados previo a la integración del primer informe de gobierno',
        'place': 'Pachuca de Soto',
        'start': '2023-05-23',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/lizquintanarg/status/1661206720234782722?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 13,
        'title': 'Instalación del Comité de Planeación para el Desarrollo Regional #Coplader de la región VIII Ixmiquilpan.',
        'place': 'Ixmiquilpan',
        'start': '2023-05-24',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1661519988618932231?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 14,
        'title': 'Audiencia Pública en la región VII Ixmiquilpan',
        'place': 'Ixmiquilpan',
        'start': '2023-05-24',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1661522995590885378?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 15,
        'title': 'Reunión con las secretarias de Cultura, Tania Meza y Medio Ambiente, Mónica Mixtega previo a la integración del primer informe de gobierno.',
        'place': 'Pachuca de Soto',
        'start': '2023-05-25',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1661848583312637959?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 16,
        'title': 'Reunión con los secretarios de Hacienda Hidalgo y del Trabajo como parte del primer informe del gobernador.',
        'place': 'Pachuca de Soto',
        'start': '2023-05-26',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1662216268467027968?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 17,
        'title': 'Reunión con autoridades estatales, municipales y representantes del IMSS para la conclusión de la Unidad Médica Familiar de Tlaxcoapan',
        'place': 'Tlaxcoapan',
        'start': '2023-05-26',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1662298931018047490?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 18,
        'title': 'Recorrido por el municipio de Atitalaquia con el Presidente Municipal, Lorenzo A. Hernández Olguín.',
        'place': 'Atitalaquia',
        'start': '2023-05-29',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1663330194713636865?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 19,
        'title': 'Reunión con los secretarios de Agricultura y representantes de la secretaría de gobierno, como parte del primer informe del gobernador.',
        'place': 'Pachuca de Soto',
        'start': '2023-05-29',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1663375994781155330?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 20,
        'title': 'Reunión con integrantes del Comité de Fraccionamientos de Hidalgo, para analizar la problemática que existe en los fraccionamientos de la zona sur y como se les puede apoyar.',
        'place': 'Pachuca de Soto',
        'start': '2023-05-30',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1663747487532740610?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 21,
        'title': 'Instalación del Comité de Planeación para el Desarrollo Regional de la Región V Mineral de la Reforma',
        'place': 'Mineral de la Reforma',
        'start': '2023-05-31',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1664089188650881024?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 22,
        'title': 'Reunión con Miguel Silíceo, titular de la Unidad de Inversiones de la Secretaría de Hacienda y Crédito Público del Gobierno de México.',
        'place': 'Pachuca de Soto',
        'start': '2023-06-02',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1664649564622659589?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 23,
        'title': 'Ceremonia cívica cargo de la Unidad de Planeación y Prospectiva',
        'place': 'Pachuca de Soto',
        'start': '2023-06-02',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1665746390109093891?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 24,
        'title': 'Participación en la reunión estratégica con las Cámaras Binacionales de Comercio de Origen Europeo en México.',
        'place': 'Pachuca de Soto',
        'start': '2023-06-05',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1665931565006716928?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 25,
        'title': 'Reunión mensual de gabinete en donde se presenta avances de los trabajos de la Unidad de Planeación y Prospectiva.',
        'place': 'Pachuca de Soto',
        'start': '2023-06-07',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1666556879617548288?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 26,
        'title': 'Reunión del gobernador Julio Menchaca con el embajador de Francia en México a la que asistió el titular de la UPLAPH',
        'place': 'Pachuca de Soto',
        'start': '2023-06-08',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/juliomenchaca_/status/1666906967980294148?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 27,
        'title': 'Copladem',
        'place': 'Pachuca de Soto',
        'start': '2023-06-09',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1667296714682777603?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 28,
        'title': 'Renovación del Consejo Directivo del Colegio de Economistas del Estado de Hidalgo.',
        'place': 'Pachuca de Soto',
        'start': '2023-06-10',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1667519872023031810?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 29,
        'title': 'Presentación de la Ruta Hidalgo 2030, Transformación para un Desarrollo Sostenible e Inclusivo.',
        'place': 'Pachuca de Soto',
        'start': '2023-06-12',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://t.co/pnE5w2QjD0"></a></p><a href="=https://twitter.com/planeacionhgo/status/1668368408335753216?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
      'id': 30,
      'title': 'Coplader',
      'place': 'Actopan',
      'start': '2023-06-14',
      'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1669078629261750273?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 31,
        'title': 'Audiencia Pública',
        'place': 'Actopan',
        'start': '2023-06-14',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1669106609706942466?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
      'id': 32,
      'title': 'Reunión con Presidentes Municipales',
      'place': 'Zimapán',
      'start': '2023-06-15',
      'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1669539614804135936?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 33,
    'title': 'Recorrido por los fraccionamientos del sur y el bordo en Pachuca de Soto.',
    'place': 'Pachuca de Soto',
    'start': '2023-06-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1669850687771901956?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 34,
    'title': 'Recorrido por las comunidades de Pueblo Nuevo, Capula, Maguey Blanco, San Nicolás y Loma de Oro, pertenecientes a Ixmiquilpan',
    'place': 'Ixmiquilpan',
    'start': '2023-06-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1670986033574432769?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 35,
    'title': 'Banderazo de inicio junto con la Presidenta Municipal y el titular de SIPDUS de la obra de rehabilitación de pavimento asfáltico de la Av. Felipe Ángeles de Ixmiquilpan.',
    'place': 'Ixmiquilpan',
    'start': '2023-06-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671234383435517953?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 36,
    'title': 'Apertura de auditoría a la cuenta pública 2022 de la Unidad de Planeación y Prospectiva, con el titular de la Auditoría Superior del Estado de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-06-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671347259072446464?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 37,
    'title': 'Reunión con el Presidente de la CMIC Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-06-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671549421262106624?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 38,
    'title': 'Reunión con el Presidente de la CMIC Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-06-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671549421262106624?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 39,
    'title': 'Instalación del Coplader Región I Tula de Allende.',
    'place': 'Tula de Allende',
    'start': '2023-06-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671549421262106624?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 40,
    'title': 'Audiencia Pública: Acuerdo con el Pueblo en Tula de Allende.',
    'place': 'Tula de Allende',
    'start': '2023-06-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1671643452944142337?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
    'id': 41,
    'title': 'Instalación del Coplader de la Región II Tulancingo.',
    'place': 'Tulancingo de Bravo',
    'start': '2023-06-28',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1674143087990325248?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 42,
    'title': 'Participación en la Audiencia Pública de Tulancingo.',
    'place': 'Tulancingo de Bravo',
    'start': '2023-06-28',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1674169915610202112?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 43,
    'title': 'Recorrplaceo por San Bartolo Tutotepec con el presplaceente municipal y representantes de la Secretaría de Cultura.',
    'place': 'San Bartolo Tutotepec',
    'start': '2023-06-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1674529194045308930?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },  
  {
    'id': 44,
    'title': 'Recorrido.',
    'place': 'El Arenal ',
    'start': '2023-06-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1674975925354520576?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 45,
    'title': 'Recorrido y reunión de trabajo.',
    'place': 'San Agustín Tlaxiaca ',
    'start': '2023-07-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1675960505238802432?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 46,
    'title': 'Reunión de gabinete.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1676753364263006208?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 47,
    'title': 'Reunión con Secretarios.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/esther_ramirezv/status/1677049850855141381?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id':48,
    'title': 'Reunión con Secretario de Desarrollo Económico.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/sedeco_hgo/status/1677181510653444096?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 49,
    'title': 'Revisión de las problemáticas que existen en el municipio de Tula y la forma de apoyarlos, a través del gobierno de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-07', 
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1677440952506413057?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 50,
    'title': 'Reunión con titulares y representantes de las dependencias del gobierno del estado a fin de evaluar acciones y proyectos.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-07', 
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1677502976540266496?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 51,
    'title': 'Conmemoración del 477 aniversario de la fundación de Actopan, en donde se aprobó el Decreto que declara al municipio como "Ciudad de la Cultura".',
    'place': 'Actopan',
    'color': 'var(--wine)',
    'start': '2023-07-08',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1677864468586418176?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 52,
    'title': 'Instalación del Coplader de la Región XII Jacala.',
    'place': 'Jacala de Ledezma',
    'start': '2023-07-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1679226551483904000?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 53,
    'title': 'Audiencia pública en Jacala de Ledezma para dar continuplacead al Acuerdo con el Pueblo, establecplaceo por el gobernador del estado.',
    'place': 'Jacala de Ledezma',
    'start': '2023-07-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1679275221696630787?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 54,
    'title': 'Reunión con representantes de la "Unión de Ejplaceatarios y Campesinos de Pachuca.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1679689006307524610?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 55,
    'title': 'Reunión con autorplaceades del IPN, campus Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1679897701796786177?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 56,
    'title': 'Sesión de trabajo en Canacintra.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-18',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1681372694883729434?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 57,
    'title': 'Anuncio perforación de seis pozos para suministrar agua en Pachuca, Mineral de la Reforma,y Zempoala.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1681772060870049794?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 58,
    'title': 'Instalación del Coplader en la región X Apan.',
    'place': 'Apan',
    'start': '2023-07-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1681793267174604805?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 59,
    'title': 'Audiencia pública en Apan.',
    'place': 'Apan',
    'start': '2023-07-19',
    'color': 'var(--wine)',  
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1681821496778403840?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 60,
    'title': 'Participación en la mesa interinstitucional para la prevención y mitigación del maltrato animal.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1682133948887965696?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 61,
    'title': 'Participación en el proyecto para elaborar los Atlas de Riesgos Municipales con la Secretarías de Gobierno, Hacienda y Educación de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1682213732758491136?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 62,
    'title': 'Asistencia al Foro de Conclusiones: Ciencia, Tecnología e Innovación como vía de desarrollo sustentable en Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-25',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1683925886532489216?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 63,
    'title': 'Reunión con la titular de cultua, Tania Meza Escorza',
    'place': 'Pachuca de Soto',
    'start': '2023-07-27',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/taniameza_/status/1684547026938126337?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 64,
    'title': 'Acompañe al Gobernador Julio Menchaca a la inauguración del Curso de Verano 2023, junto al DIF Hplacealgo y la Oficialía Mayor.',
    'place': 'Pachuca de Soto',
    'start': '2023-07-28',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1686134757908680709?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 65,
    'title': 'El Gobernador Julio Menchaca encabezó la primera Sesión Ordinaria de la Comisión de Ordenamiento Metropolitano de la Zona Metropolitana de Pachuca.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-02',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1686852125362356224?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 66,
    'title': 'El titular de la UPLAPH, Miguel Ángel Tello Vargas realizó un recorrido en el municipio de El Cardonal para definir poryectos y participar en el arranque de la obra: Equipamiento de pozo, ramal eléctrico y línea de conducción del manantial salinas.',
    'place': 'El Cardonal', 
    'start': '2023-08-03',  
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1687233335448199169?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 65,
    'title': 'Reunión mensual de gabinete para evaluar acciones y programas realizados en los primeros once mesesde administración.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-07',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1688613110444122113?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 66,
    'title': 'Reunión con Jorge Márquez, Presplaceente Municipal de Tulancingo.',
    'place': 'Tulancingo de Bravo',
    'start': '2023-08-07',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/marquezajorge/status/1688709073318141952?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 67,
    'title': 'La Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible, la Unidad de Planeación y Prospectiva, la Secretaría de Desarrollo Económico y los municipios impulsan estrategias para el crecimiento y la competitividad económica de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-08',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/sedeco_hgo/status/1689045002108772352?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 68,
    'title': 'En reunión con la titular de Hacienda, Esther Ramírez Vargas, analizamos distintos proyectos realizados de manera conjunta rumbo a la contrucción del Presupuesto 2024.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-08',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/esther_ramirezv/status/1689109597573836800?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 69,
    'title': 'Recorrido en el Ferrocarril y la Maestranza',
    'place': 'Pachuca de Soto',
    'start': '2023-08-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1690502981697884160?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 70,
    'title':'Reunión con secretarias de Hacienda, Medio Ambiente y Movilidad y Transporte.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1691254213794463745?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 71,
    'title': 'Reunión con Secretarios de Hacienda, Turismo, Agricultura y Trabajo y Previsión Social.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1691652819667882435?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 72,
    'title': 'Reunión proyectos de gasto de inversión 2024 de las Secretarías de Educación, Salud y Segurplacead Pública.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1692907105601134834?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 73,
    'title': 'Reunión proyectos de gasto de inversión 2024 de la secretaría de Contraloría y Procuraduría.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1693741011690729910?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 74,
    'title': 'Reunión proyectos de gasto de inversión 2024 de la Secretaría de Cultura y la Oficialía Mayor.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1694153950033805718?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 75,
    'title': 'Presentación de beneficiarios de las Becas de Posgrado de Excelencia para Maestría en el Extranjero.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1694451037334024657?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 76,
    'title': 'Reunión proyectos de gasto de inversión 2024 de la Secretaría de Gobierno.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1694553731994431861?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 77,
    'title': 'Firma de Convenio Marco entre el Gobierno del Estado de Hidalgo y el Instituto Nacional de Antropoligía e Historia.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-24',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://x.com/juliomenchaca_/status/1694863630703984700?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 78,
    'title': 'Reunión con Sistema de Naciones Unidas.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-25',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1695174668951621945?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 79,
    'title': 'Reunión con Servidores públicos de la Unidad de Planeación y Prospectiva.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-26',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1695500780881518904?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 80,
    'title': 'Entrega de apoyos de Pemex.',
    'place': 'Pachuca de Soto',
    'start': '2023-08-26',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1695592614412554470?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 81,
    'title': 'Primer Encuentro Nacional de Autoridades de Mejora Regulatoria.',
    'place': 'Ciudad de México',
    'start': '2023-08-28',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1696277787370295493?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 82,
    'title': 'Entrega del programa de becas "Construyendo Comunidades Sólidas".',
    'place': 'Ixmiquilpan',
    'color': 'var(--wine)',
    'start': '2023-08-29',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1696613358907105369?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 83,
    'title': 'Consejo Consultivo del Aeropuerto Internacional Felipe Ángeles.',
    'place': 'Zumpango',
    'color': 'var(--wine)',
    'start': '2023-08-31',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1697348238326616256?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 84,
    'title': 'Primer informe del gobernador, Julio Menchaca.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1699214923400610137?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 85,
    'title': 'Subcomité Especial de Planeación de Oficialía Mayor.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1699536941610369442?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 86,
    'title': 'Reunión con titular de los Programas de Prevención del Delito y Justicia Penal de UNODC México.',
    'place': 'Ciudad de México',
    'start': '2023-09-07',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1699942238753903014?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 87,
    'title': 'Reunión de gasto de inversión con el Secretario de Desarrollo Económico.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-08',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1700255807840137486?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 88,
    'title': 'Informe del Presidente municipal de Chilcuautla.',
    'place': 'Chilcuautla',
    'color': 'var(--wine)',
    'start': '2023-09-09',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1700629341275611378?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 89,
    'title': 'Informe del Presidente municipal de Zimapán.',
    'place': 'Zimapán',
    'color': 'var(--wine)',
    'start': '2023-09-11',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1701442312205648223?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 90,
    'title': 'Reunión de gasto de inversión con el Secretario de Infraestructura Pública y Desarrollo Urbano Sostenible.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1701711240433651982?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 91,
    'title': 'Reunión del Consejo de Desarrollo Metropolitano del Valle de México.',
    'place': 'Ciudad de México',
    'start': '2023-09-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1701808137601188219?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 92,
    'title': 'Lanzamiento del paquete Informativo en México, RGMX-UK',
    'place': 'San Agustín Tlaxiaca',
    'start': '2023-09-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1702085314091614383?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 93,
    'title': 'Inauguración del Centro Alterno de Monitoreo del Servicio Sismologico Nacional',
    'place': 'San Agustín Tlaxiaca',
    'start': '2023-09-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1702425699120755129?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 94,
    'title': 'Develación de mural e inicio del programa Pintando la Transformación',
    'place': 'Ixmiquilpan',
    'color': 'var(--wine)',
    'start': '2023-09-14',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1702534969053077853?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 95,
    'title': 'Reunión con Secretarios de Gobierno y Agricultura de Hidalgo, así como Presidentes Municipales.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-18',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1703895284785307973?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 96,
    'title': 'Asistencia al 3er Informe de labores de la presidenta municipal de Ixmiquilpan, Araceli Beltrán.',
    'place': 'Ixmiquilpan',
    'color': 'var(--wine)',
    'start': '2023-09-19',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1704308883966054476?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 97,
    'title': 'Asistencia al 3er Informe de labores del presidente municipal de Alfajayucan, Alfredo Feregrino.',
    'place': 'Alfajayucan',
    'color': 'var(--wine)',
    'start': '2023-09-20',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1704595679304138844?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 98,
    'title': 'Asistencia al 3er Informe de labores del presidente municipal de Cardonal, Mariano Cabañas.',
    'place': 'Cardonal',
    'color': 'var(--wine)',
    'start': '2023-09-20',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1704654007833153764?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 99,
    'title': 'Asistencia al 3er Informe de labores de la presidenta municipal de Tasquillo, Estela Martínez. ',
    'place': 'Tasquillo',
    'color': 'var(--wine)',
    'start': '2023-09-20',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1704691795215454210?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 100,
    'title': 'Participación en el 3er Taller ConEstados 2023 de Coneval, denominado "El proceso de evaluación de la política Social de las entidades federativas".',
    'place': 'Pachuca de Soto',
    'start': '2023-09-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1705290745291342231?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 101,
    'title': 'Asistencia a la Celebración del 28 aniversario del CCEH.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1705426826565185946?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 102,
    'title': 'Participación a la reunión de coordinación interinstitucional entre el Gobierno de Hidalgo y diversas representaciones del Gobierno de México',
    'place': 'Pachuca de Soto',
    'start': '2023-09-25',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1706438359835344998?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'  
  },
  {
    'id': 103,
    'title': 'Reunión de la titular de Hacienda Hidalgo, con el equipo de la Unidad de Planeación y sus organismos públicos descentralizados para analizar los proyectos de gasto de inversión 2024.',
    'place': 'Pachuca de Soto',
    'start': '2023-09-26',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1706767789099196772?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 104,
    'title': 'Visita a diversas comunidades de Ixmiquilpan para atender necesidades y demandas.',
    'place': 'Ixmiquilpan',
    'start': '2023-09-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1707879775254053153?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 105,
    'title': 'Reunión mensual de gabinete.',
    'place': 'Pachuca de Soto',
    'start': '2023-10-04',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1709730512787423594?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 106,
    'title': 'Primer Informe de Actividades del PJEHidalgo y el Consejo de la Judicatura de la Magistrada Presidenta Rebeca Aladro Echeverría.',
    'place': 'Pachuca de Soto',
    'start': '2023-10-',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1709668827837927684?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 107,
    'title': 'Webinar "bienestar animal, un camino hacia la paz", realizado en coordinación con la Procuraduría General de Justicia de Hidalgo y la Universidad Nacional Autónoma de México.',
    'place': 'Pachuca de Soto',
    'start': '2023-10-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1709979647209881999?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 108,
    'title': 'Revisión de proyectos de prioridad para el ejercicio 2024, a fin de garantizar la atención a la ciudadanía en temas de prevención y riesgos con la titular de la Secretaría de Hacienda y el subsecretario de Protección Civil y Gestión de Riesgos.',
    'place': 'Pachuca de Soto',
    'start': '2023-10-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/Esther_RamirezV/status/1712294176195215676?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 109,
    'title': 'Comparecencia ante los diputados de la LXV legislatura del Congreso de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2023-10-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/PlaneacionHgo/status/1712681412120187171?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 110,
    'title': 'En representación del gobernador Julio Menchaca, Miguel Ámgel Tello Vargas, recibió el reconocimiento que el Coneval otorgó al Gobierno de Hidalgo por obtener el puntaje más alto en la regulación e implementación de instrumentos de monitoreo y evaluación',
    'place': 'Ciudad de México',
    'start': '2023-10-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://x.com/planeacionhgo/status/1715548798217261435?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 111,
    'title': 'Reunión con la Coordinadora de Planeación e Inversión del Gobierno de Tlaxcala para estrechar lazos de colaboración entre Hidalgo y Tlaxcala',
    'place': 'Tlaxcala',
    'start': '2023-10-24',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://x.com/planeacionhgo/status/1716971122262937954?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 112,
    'title': 'Miguel Ángel Tello Vargas asistió al primer informe de labores de laPresidente del DIF Hidalgo, Edda Vite Ramos',
    'place': 'Pachuca de Soto',
    'start': '2023-10-25',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1717298402126414333?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 113,
    'title': 'Con el propósito de presentar proyectos y acciones que detonen el desarrollo de la Zona Metropolitana del Valle de México en torno al AIFA, el titular de la Unidad de Planeación y Prospectiva se reunió con el titular del AIFA, General Isidoro Pastor, así como con representantes del Estado de México, CDMX, y SEDATU.',
    'place': 'Estado de México',
    'start': '2023-10-26',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://x.com/planeacionhgo/status/1717625940266672372?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 114,
    'title': 'Miguel Ángel Tello V, acompañó al gobernador, Julio Menchaca, a la reinauguración del Museo Jorge R. Acosta Zona de Monumentos Arqueológicos de Tula',
    'place': 'Tula de Allende',
    'start': '2023-10-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://x.com/planeacionhgo/status/1719191603384881438?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 115,
    'title': 'Recorrido por diferentes municipios de la Huasteca Hidalguense ',
    'place': 'Yahualica, Xochíatipan, Atlapexco, Jaltocan',
    'start': '2023-10-31',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1719590251273101458?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 116,
    'title': 'Instalación dl Subcomité Especial del Sistema de Monitoreo y Evaluación de la Política Pública y Primera Sesión Ordinaria. ',
    'place': 'Pachuca de Soto',
    'start': '2023-11-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1724182943411630489?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ    "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 117,
    'title': 'Rutas de la Transformació en Tenango de Doria.',
    'place': 'Tenango de Doria ',
    'start': '2023-11-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1724552347798352355?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ     "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 118,
    'title': 'Presentación de la ponencia "El desarrollo de la industria 4.0" en el Foro "Hacia la construcción de la industria 4.0 en el Estado de Hidalgo".',
    'place': 'Pachuca de Soto',
    'start': '2023-11-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1724913822471782661?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ      "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 119,
    'title': 'Recorrdio por diferentes parcelas del ejido Zozea, como parte del proyecto del canal de interconexión de la presa El Yathé',
    'place': 'Alfajayucan',
    'start': '2023-11-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1725281469902283217?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ       "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 120,
    'title': 'Rutas de la Transformación en Cardonal, Hidalgo.',
    'place': 'Cardonal',
    'start': '2023-11-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/juliomenchaca_/status/1727083635138769329?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 121,
    'title': 'Presentación de resultados del proyecto Seguridad Humana, en colaboración con los repesentantes en México de ONUDI, UNODC y UNFPA.',
    'place': 'San A. Tlaxiacal',
    'start': '2023-11-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1727414810898481441?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 122,
    'title': 'Participación en el Congreso Parques 2023, en el marco de la Semana Internacional de Planeación, Arquitectura y Espacio Público.',
    'place': 'León Guanajuato',
    'start': '2023-11-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1727865935564820921?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 123,
    'title': 'Aprobación del Programa de Ordenación de la Zona Metropolitana del Valle de México en la Segunda Sesión Ordinaria del Consejo de Desarrollo Metropolitano del Valle de México',
    'place': 'AIFA Zumpago, Estado de México',
    'start': '2023-11-24',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1728178093725212812?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 124,
    'title': 'El gobernador  Julio Menchaca, entregó el Premio Hidalgo de Ciencia, Tecnología e Innovación 2023',
    'place': 'CITNOVA - San A. Tlaxiaca',
    'start': '2023-11-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1729999497961607546?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 125,
    'title': 'Tercera Sesión Ordinaria del Copladem de Tulancingo, en donde se dio seguimiento a las obras y acciones del municipio',
    'place': 'Tulancingo de Bravo',
    'start': '2023-11-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1730341725334368407?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 126,
    'title': '55 aniversario de la Estación Terrena Tulancingo',
    'place': 'Tulancingo de Bravo',
    'start': '2023-11-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1730404314349179217?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 127,
    'title': 'Miguel Ángel Tello Vargas impartió la conferencia "La Planeación en el Gobierno del Estado de Hidalgo: Importancia para el Desarrollo" en la Universidad Pedagógica Nacional Hidalgo,',
    'place': 'Pachuca de Soto',
    'start': '2023-12-01',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1730769633613844692?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 128,
    'title': 'Presentación de la Estrategia de Fortalecimiento Regional para el Desarrollo Socioeconómico del estado de Hidalgo',
    'place': 'Pachuca de Soto',
    'start': '2023-12-01',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/planeacionhgo/status/1730964747225280585?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 129,
    'title': '"Capacitación sobre "Herramientas de Monitoreo y Evaluación para la Medición de Resultados", por parte de expertos del Coneval y la Cepal-ONU"',
    'place': 'DESCTI - San A. Tlaxiaca',
    'start': '2023-12-04',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1731748044868116903?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 130,
    'title': 'Última reunión de gabinete del 2023, convocada por nuestro gobernador, Julio Menchaca',
    'place': 'Pachuca de Soto',
    'start': '2023-12-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1732054680828600350?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 131,
    'title': 'Presentación del proyecto insignia  la Oficina de las Naciones Unidas contra la Droga y el Delito, relacionado con acciones implementadas en la prevención del delito en el municipio de Querétaro.',
    'place': 'Querétaro',
    'start': '2023-12-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1732197669211099589?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 132,
    'title': 'Segunda Sesión Ordinaria de la Comisión Hidalguense de Investigación, Desarrollo Tecnológico e Innovación.',
    'place': 'CITNOVA - San A. Tlaxiaca',
    'start': '2023-12-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1732527505322434954?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 133,
    'title': '9ª y 10ª Sesiones Ordinarias del Consejo Nacional de Mejora Regulatoria en representación del Gobernador Julio Menchaca',
    'place': 'CDMX',
    'start': '2023-12-08',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href="https://twitter.com/mtellov/status/1733208800109179235?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 134,
    'title': 'Instalación del Comité de Desarrollo Regional (COPLADER) de Pachuca.',
    'place': 'San A. Tlaxiaca',
    'start': '2023-12-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/planeacionhgo/status/1735076174538162442?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 135,
    'title': 'Participación en la Segunda Sesión Ordinaria del Subsistema Nacional de Información de Gobierno, Seguridad Pública e Impartición de Justicia con el tema "Información Estadística en la Planeación Estatal de Hidalgo',
    'place': 'Virtual',
    'start': '2023-12-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/planeacionhgo/status/1735490139781029893?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 136,
    'title': 'Visita al Centro de Alto Rendimiento para presentar los proyectos y las iniciativas destinadas a potenciar el rendimiento y bienestar de las y los atletas hidalguenses.',
    'place': 'Pachuca de Soto',
    'start': '2023-12-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1735768235725734123?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 137,
    'title': 'Primera reunión de gabinete del 2024, en donde se traza el camino que seguirá impulsando el bienestar en nuestro estado.',
    'place': 'Pachuca de Soto',
    'start': '2024-01-08',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/juliomenchaca_/status/1744556802229080571?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 138,
    'title': 'En coordinación con la Asociación Nacional de Parques y Recreación de México, se construye una ruta estratégica para contar con mejores espacios públicos en beneficio de las y los hidalguenses.',
    'place': 'Pachuca de Soto',
    'start': '2024-01-10',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1745292692924289093?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 139,
    'title': 'Ceremonia por el 155 aniversario de la Erección del Estado de Hidalgo, presidida por el Gobernafdor del Estado, Julio Menchaca Salazar',
    'place': 'Pachuca de Soto',
    'start': '2024-01-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1747328505858187309?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 140,
    'title': 'Instalación del Subcomité Especial del Geoparque de la Comarca Minera',
    'place': 'Pachuca de Soto',
    'start': '2024-01-17',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1747731954621882472?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 141,
    'title': 'Los equipos de trabajo de la Secretaría de Desarrollo Económico y de la Unidad de Planeación, coordinan acciones para 2024, en materia de crecimiento y desarrollo económico',
    'place': 'Pachuca de Soto',
    'start': '2024-01-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1749966750060322876?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 142,
    'title': 'Se establecieron mesas intersecretariales para prospectar un futuro mejor que impulse a Hidalgo hacia su máximo potencial.',
    'place': 'Pachuca de Soto',
    'start': '2024-01-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/sedeco_hgo/status/1747830914573353415?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 143,
    'title': 'Inauguración del Centro Estatal de la Asociación de Hospitales Privados en el DESCTI',
    'place': 'San A, Tlaxiaca',
    'start': '2024-01-26',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/planeacionhgo/status/1751015267189051761?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 144,
    'title': 'Entrevista al Secretario de Planeación y Prospectiva, Miguel A. Tello',
    'place': 'Pachuca de Soto',
    'start': '2024-01-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/cafeconpiquete1/status/1752144458257199191?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 145,
    'title': 'Cuarta Sesión Ordinaria del COPLADEM de Zimapán',
    'place': 'Zimapán',
    'start': '2024-01-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/planeacionhgo/status/1752438275954897258?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 146,
    'title': 'Reunión vía zoom sobre el Programa de Fomento a la Planeación Urbana, Metropolitana y Ordenamiento Territorial',
    'place': 'Pachuca de Soto',
    'start': '2024-02-01',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1753184926856364478?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 147,
    'title': 'Reunión con el equipo de Planeación para impulsar acciones y proyectos que aseguran el bienestar de cada hidalguense',
    'place': 'Pachuca de Soto',
    'start': '2024-02-01',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1753208120187158670?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 148,
    'title': 'El gobernador, Julio Menchaca y la presidenta del INEGI, Graciela Márquez Colín firmaron el convenio del Comité de Información Estadística y Geográfica de Hidalgo',
    'place': 'Pachuca de Soto',
    'start': '2024-02-02',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1753482829869322740?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 149,
    'title': 'Reunión mensual de gabinete, encabezada por el gobernador, Julio Menchaca.',
    'place': 'Pachuca de Soto',
    'start': '2024-02-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1754640624467243077?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 150,
    'title': 'Entrevista en el estudio de Central MX.',
    'place': 'Pachuca de Soto',
    'start': '2024-02-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/central_mxh/status/1755063680457224488?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 151,
    'title': 'Reunión con representantes textiles de Cuautepec para establecer una colaboración entre empresas, academia y gobierno, a fin de cumplir los compromisos establecidos por el gobernador, Julio Menchaca en la región de Tulancingo.',
    'place': 'Cuatepec de Hinojosa',
    'start': '2024-02-07',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1755332443052060758?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 152,
    'title': 'Presentación del Programa Generación 2030 a los estudiantes de la Universidad Politécnica Metropolitana con la participación de Alanna Armitage, representante de Fondo de Población de la Naciones Unidas México (UNFPA)',
    'place': 'Tolcayuca',
    'start': '2024-02-09',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1756071651517599954?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 153,
    'title': 'Participación en el Taller del Programa de Ordenamiento Ecológico Local de Tizayuca, con la Presidenta Municipal, Susana Ángeles Quezada.',
    'place': 'Tizayuca',
    'start': '2024-02-10',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1756384431164776913?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 154,
    'title': 'Recorrido en el  Centro Educativo Ambiental Sustentable "Yolitia", en este espacio se generará un desarrollo sustentable y de sana convivencia entre la población.',
    'place': 'Tizayuca',
    'start': '2024-02-10',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1756446063731277829?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 155,
    'title': 'Presentación del Atlas de Riesgo del municipio de Tulancingo con la intervención de Jorge Márquez Alvarado, Presidente Municipal con la colaboración del gobierno del estado.',
    'place': 'Tulancingo de Bravo',
    'start': '2024-02-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1757524493226881340?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 156,
    'title': 'Participación en el Foro de Consulta Municipal de Desarrollo Urbano de Cuautepec, impulsado por Sedatu.',
    'place': 'Cuautepec de Hinojosa',
    'start': '2024-02-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1757562736773366186?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 157,
    'title': 'Reunión con ejidatarios de Zozea con el objetivo de continuar los la mesas de trabajo para el proyecto del canal de interconexión de la presa El Yathé',
    'place': 'Alfajayucan',
    'start': '2024-02-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1758608891988869463?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 158,
    'title': 'Recorrido para estructurar la segunda etapa del Parque Municipal de Ixmiquilpan "Benito Juárez", primer proyecto de varios que se rehabilitarán en Hidalgo.',
    'place': 'Ixmiquilpan',
    'start': '2024-02-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1758630240782311821?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 159,
    'title': 'Primer encuentro de Centros Comunitarios DIFPILARES, presidido por el gobernador Julio Menchaca y Edda Vite Presidenta del DIF Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2024-02-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1759690874433175847?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 160,
    'title': 'Primera Sesión Ordinaria del Subcomité del Geoparque de la Comarca Minera, que impulsa el avance y la consolidación del Geoparque en beneficio de las comunidades hidalguenses.',
    'place': 'San A.Tlaxiaca',
    'start': '2024-02-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1759745588470448270?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 161,
    'title': 'El gobernador, Julio Menchaca entregó  el Certificado ISO 9001 Y 37001 a servidoras y servidores públicos, reafirmando su compromiso con la cercanía y la transparencia al pueblo.',
    'place': 'Pachuca de Soto',
    'start': '2024-02-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1759985940943012337?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 162,
    'title': 'Visita del alcalde de Hunán, provincia de China, reconocida por su desarrollo tecnológico y turístico, con el propósito de conocer las iniciativas del gobierno de Hidalgo en estos ámbitos, platicamos sobre la posibilidad de colaborar y compartir buenas prácticas para fortalecerlos.',
    'place': 'San A.Tlaxiaca',
    'start': '2024-02-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760054269590282369?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 163,
    'title': 'Sedatu presentó el Proyecto Piloto Desarrollo Orientado al Transporte en los alrededores del AIFA, el Tren Suburbano y el Tren Interurbano, además de los municipios de la Zona Norte del Valle de México.',
    'place': 'Santa Lucía',
    'start': '2024-02-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760412147115254130?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 164,
    'title': 'Sesión ordinaria del Copladem de Tula, donde reiteré mi compromiso de trabajar de manera conjunta con el municipio en beneficio de todos sus habitantes.',
    'place': 'Tula de Allende',
    'start': '2024-02-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760780699928318393?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ  "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 165,
    'title': 'Encuentro con habitantes de Tepeji del Río, junto a la diputada Tania Valdez, escuchamos sus inquietudes, demandas y problemáticas para buscar respuestas y medidas efectivas.',
    'place': 'Tepeji del Río de Ocampo',
    'start': '2024-02-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760795380709482514?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 166,
    'title': 'Recorrido por diversas zonas del municipio de Tepeji del Río, junto al presidente municipal, Salvador Jiménez Calzadilla, con el fin de coordinar acciones para fortalecer y abordar las necesidades de los habitantes.',
    'place': 'Tepeji del Río de Ocampo',
    'start': '2024-02-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760868500845838530?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 167,
    'title': 'Agradezco la invitación a la comunidades de Santa María Magdalena Hidalgo y Cantera de Villagran, en Tepeji del Río, para escucharles, tomar decisiones con responsabilidad y velar por el bienestar de todas y todos.',
    'place': 'Tepeji del Río de Ocampo',
    'start': '2024-02-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1760841989157773511?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  
  {
    'id': 168,
    'title': 'Reunión para analisis de proyectos de la Zona Metropolitana de Pachuca',
    'place': 'Pachuca',
    'start': '2024-06-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1797757660726505810?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 169,
    'title': 'Reunión con Oscar Pérez Rojas, Director del Instituto Hidalguense del Deporte.',
    'place': 'Pachuca',
    'start': '2024-06-04',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1798007512517734512?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 170,
    'title': 'Inauguración de la Semana de la Evaluación #gLOCAL2024',
    'place': 'Pachuca',
    'start': '2024-06-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1798450699153678748?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 171,
    'title': 'Reunión mensual de gabinete',
    'place': 'Pachuca',
    'start': '2024-06-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1798521206158889422?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 172,
    'title': 'Reunión mensual de gabinete',
    'place': 'Pachuca',
    'start': '2024-07-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1809428022212096065?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 173,
    'title': 'Recorrido en viveros',
    'place': 'Tepeapulco y Singuilucan',
    'start': '2024-06-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1801794676866896277"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 174,
    'title': 'Reunión con Elías Paso, Presidente Municipal',
    'place': 'Tecozautla',
    'start': '2024-06-18',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1803075225136807960?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 175,
    'title': 'Recorrido en viveros',
    'place': 'Huichapan y Zimapan',
    'start': '2024-06-18',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1803190428268659185?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 176,
    'title': 'Dimos la bienvenida a evaluadores de la UNESCO por parte del Gobierno de Hidalgo, la UNAM y La Salle, ',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-06-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1803589541850161413?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 177,
    'title': 'Reunión de gabinete con el Gobernador del Estado, Julio Menchaca Salazar',
    'place': 'Pachuca de Soto',
    'start': '2024-07-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1809428022212096065?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 178,
    'title': '¡Felicidades a mis 384 ahijados y ahijadas de la generación 2021-2024 del CETIS No. 026 de Atitalaquia!',
    'place': 'Atitalaquia',
    'start': '2024-07-09',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1810789905234284746?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },  
  {
    'id': 179,
    'title': 'Reunión con el Dr- Arturo Reyes, Director General del IPN, para revisar el proyecto de ampliación de infraestructura del campus Hidalgo, ubicado en el DECSTI. Además, se propuso crear un espacio público abierto para los estudiantes.',
    'place': 'CDMX',
    'start': '2024-07-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1813013437070336008?t=whrD0skRCBpaVNpFVj1IKg&s=08"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 180,
    'title': 'Me reuní con el Secretario Ejecutivo del Consejo Nacional de Evaluación de la Política de Desarrollo Social, José Nabor Cruz, con el propósito de analizar la situación actual del Padrón Único de Beneficiarios y del Laboratorio de Políticas Públicas. Ambos proyectos se han desarrollado bajo las recomendaciones del Coneval',
    'place': 'CDMX',
    'start': '2024-07-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1813015966105604283?t=qE0qw3gVitKikhKPis9CjQ&s=08"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 181,
    'title': 'El gobernador Julio Menchaca está comprometido con la creación de un proyecto integral que fortalezca la seguridad alimentaria y la sostenibilidad en nuestro estado, además de ofrecer capacitaciones en financiamiento e inversión.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-07-17',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1813726547653902589?s=08"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 182,
    'title': 'Por ello, presentamos el Programa Integral de Fortalecimiento al Emprendimiento Agroalimentario, en coordinación con Kirchner Impact Foundation.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-07-17',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1813726549415432209?t=LOLO49VYtIOPg3bxo7sA7g&s=08 "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 183,
    'title': ' Reunión en las oficinas de la Universidad Autónoma Agraria Antonio Narro, con el Dr. Alberto Flores, y compañeros de Yolotepec de Santiago de Anaya.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-07-17',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1813726549415432209?t=LOLO49VYtIOPg3bxo7sA7g&s=08 "></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 184,
    'title': 'Reunión Mensual de Gabinete.',
    'place': 'Pachuca',
    'start': '2024-08-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1820576875904970961"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 185,
    'title': 'Entrega de plantas de maguey.',
    'place': 'Chilcuautla',
    'start': '2024-08-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1823572192300241263"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 186,
    'title': 'Inauguración del Laboratorio de Nanomateriales, Robótica e Inteligencia Artificial.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-08-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1824564149398941717"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 187,
    'title': 'Firma de convenio para la donación de 8 plataformas digitales por parte del gobierno de la CDMX al gobierno de Hidalgo. ',
    'place': 'Ciudad de México',
    'start': '2024-08-19',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1825622580990030040"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 188,
    'title': 'Primera reunión con los presidentes municipales electos.  Se llevo a cabo el día 26 de agosto de 2024, se público el día 27 de agosto del presente año.',
    'place': 'Pachuca de Soto',
    'start': '2024-08-27',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1828442609771004393"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 189,
    'title': 'Primera reunión con los presidentes municipales electos.  Se llevo a cabo el día 26 de agosto de 2024, se público el día 27 de agosto del presente año.',
    'place': 'Pachuca de Soto',
    'start': '2024-08-27',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1828442609771004393"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 190,
    'title': 'Primera reunión entre diputadas y diputados locales electos',
    'place': 'Pachuca de Soto',
    'start': '2024-08-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1829165516440961503"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 191,
    'title': 'Reunión de seguimiento con el equipo de transisión de la SEDATU MÉXICO y representantes de los gobiernos del Estado de México y Ciudad de México.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-08-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1829332985822511513"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 192,
    'title': 'Reunón de gabinete.',
    'place': 'Pachuca de Soto',
    'start': '2024-09-04',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1831460007201866025"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 193,
    'title': 'Toma de protesta de la presidenta municipal de Tlaxcoapan.',
    'place': 'Tlaxcoapan',
    'start': '2024-09-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1831805761120280736"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 194,
    'title': 'Toma de protesta del presidente municipal de Alfajayucan.',
    'place': 'Alfajayucan',
    'start': '2024-09-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1831856127471935560"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 195,
    'title': 'Toma de protesta de la presidenta municipal de Chilcuautla.',
    'place': 'Alfajayucan',
    'start': '2024-09-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1832065928101609796"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 196,
    'title': 'Segundo informe del gobernador, Julio Menchaca.',
    'place': 'Pachuca de Soto',
    'start': '2024-09-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1832207943493628201"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 197,
    'title': 'Reunión con represetnates del Gobierno del Estado de México, Gobierno de México, Sedatu México y con la titular de Movilidad Hidalgo,  para dar seguimiento a los avances del programa de ordenamiento de la Zona Metropolitana del Valle de México.',
    'place': 'Estado de México',
    'start': '2024-09-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1834356131453432020"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 198,
    'title': 'Embelleciendo los municipios, siguiendo la Ley Urbana impulsada por el gobernador Julio Mechaca.',
    'place': 'Tula de Allende',
    'start': '2024-10-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1841947030257541398"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 199,
    'title': 'Invitación a la instalación del Copladem en el municipio de Tula de Allende.      ',
    'place': 'Tula de Allende',
    'start': '2024-10-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1842214350670479527"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 200,
    'title': 'Invitación a la instalación del Copladem en el municipio de Tezontepec de Aldama.',
    'place': 'Tezontepec de Aldama',
    'start': '2024-10-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1842222396121440309"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 201,
    'title': 'Presidió la instalación del Copladem en el municipio de Tepeji del Río. ',
    'place': 'Tepeji del Río',
    'start': '2024-10-03',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1842232611776967050"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 202,
    'title': 'Reunión de gabinete.',
    'place': 'Pachuca de Soto',
    'start': '2024-10-04',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/juliomenchaca_/status/1842305578275672534"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 203,
    'title': 'Instalación del Copladem en el municipio de Villa de Tezontepec.',
    'place': 'Villa de Tezontepec.',
    'start': '2024-10-05',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1842693295593410802"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 204,
    'title': 'Recibimos a nuestra Presidenta, Claudia Sheinbaum, en Hidalgo.',
    'place': 'Tizayuca ',
    'start': '2024-10-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1843057537844949265"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 205,
    'title': 'Escuchamos de manera abierta todas las voces para lograr acuerdos en beneficio de la región.',
    'place': 'Alfajayucan',
    'start': '2024-10-11',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1845226867990655483"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 206,
    'title': 'Invitación a la tercera junta extraordinaria del Instituto Municipal de Investigación y Planeación.',
    'place': 'Pachuca de Soto',
    'start': '2024-10-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1845927608384737296"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 207,
    'title': 'Hace dos años inició la transformación en Hidalgo, comparecencia ante los diputados de la LXVI legislatura del Congreso de Hidalgo.',
    'place': 'Pachuca de Soto',
    'start': '2024-10-16',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1846737359624184257"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 208,
    'title': 'Inauguración del Centro de Distribución MX10 de Mercado Libre México.',
    'place': 'Villa de Tezontepec',
    'start': '2024-10-28',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851087928690155526"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  
  {
    'id': 209,
    'title': 'Día de Campo, Casa Cuna.',
    'place': 'San Agustín Tlaxiaca',
    'start': '2024-10-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851452369160323302"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 210,
    'title': 'Reunión Palacio Nacional.',
    'place': 'Ciudad de México',
    'start': '2024-10-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851716451922747648"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 211,
    'title': 'Reunión Agenda Metropolitana.',
    'place': 'Pachuca de Soto',
    'start': '2024-10-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851771319727329562"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 212,
    'title': 'Entrega Atlas de Riesgos.',
    'place': 'Pachuca de Soto',
    'start': '2024-10-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851805473810342297"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 213,
    'title': 'Segunda etapa de reforestación masiva en el municipio de Tula de Allende.',
    'place': 'Tula de Allende',
    'start': '2024-10-30',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1851976822524715285"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 214,
    'title': 'Evento ¡La Noche de las Estrellas!',
    'place': 'Santiago Tulantepec',
    'start': '2024-11-10',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1855643270866407788"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 215,
    'title': 'Conferencia de prensa de BIKEFEST en Hidalgo',
    'place': 'Huasca de Ocampo',
    'start': '2024-11-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1856448131732300061"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 216,
    'title': 'Reunión Agenda Metropolitana.',
    'place': 'Estado de México',
    'start': '2024-11-13',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1856814471382962270"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 217,
    'title': 'Reunión con el Consejo Directivo de Canadevi.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-14',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1857153817051017413"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 218,
    'title': 'Semana de la Evalución gLOCAL 2024.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-15',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1857585308151263434"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 219,
    'title': 'Invitación al Congreso Internacional Falling Walls Engage Hub México 2024.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-20',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1859411565864419535"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 220,
    'title': 'Reunión de cabildos.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-21',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1859610362758504741"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 221,
    'title': 'Rueda de prensa Foro Participativo Hidalgo Conecta',
    'place': 'Pachuca de Soto',
    'start': '2024-11-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1860057751315185813"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 222,
    'title': 'Sexta Sesión Ordinaria del Subcomité Sectorial de Educación del COPLADEHI.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1860089368242786597"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 223,
    'title': 'Celebraciób de la clausura y premiación del Programa AGTECH Summit Hidalgo 2024.',
    'place': 'San Agusín Tlaxiaca',
    'start': '2024-11-22',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1860135244818710825"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 224,
    'title': 'Con el inicio de los Foros Hidalgo Conecta, se diseña la Ley de Gobernanza Digital.',
    'place': 'Pachuca de Soto',
    'start': '2024-11-27',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1861849404149268695"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 225,
    'title': 'Entrega de leche ',
    'place': 'Mixquiahuala',
    'start': '2024-11-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1862600943834989051?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 226,
    'title': 'Participación en la Red Nacional Metropolitana 2024',
    'place': 'Tlaxcala',
    'start': '2024-11-29',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1862694680648970653?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 227,
    'title': 'COPLADEHI de la Secretaría de Agricultura',
    'place': 'Pachuca de Soto',
    'start': '2024-12-02',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1863678187533930813?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 228,
    'title': 'Presentación de la Estrategia de Simplificación Administrativa',
    'place': 'Pachuca de Soto',
    'start': '2024-12-02',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1863758788874084464?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 229,
    'title': 'Reunión de Gabinete',
    'place': 'San Agustín Tlaxiaca ',
    'start': '2024-12-02',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1864835800808198271?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 230,
    'title': 'Primer Encuentro de la Megalópolis. ',
    'place': 'Pachuca de Soto',
    'start': '2024-12-09',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1866241322199228477"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 231,
    'title': 'Reunión con representantes de los distritos de riego de Tula, Ajacuba y Alfajayucan. ',
    'place': 'Pachuca de Soto',
    'start': '2024-12-10',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1866502793646743931"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 232,
    'title': 'Encuentro con Proveedores de Equipo para Riego Tecnificado. ',
    'place': 'Pachuca de Soto',
    'start': '2024-12-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1867365202288947676"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 233,
    'title': 'Sesiones Ordinarias I, II y III DEL Consejo Estatal de Mejora Regulatoria. ',
    'place': 'Pachuca de Soto',
    'start': '2024-12-12',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1869481368704749899?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 234,
    'title': 'Firma del Convenio para la Tecnificación de los Distritos de Riego en el Valle del Mezquital.',
    'place': 'Actopan',
    'start': '2024-12-23',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1871303897689805127"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
 
  {
    'id': 235,
    'title': 'Partida de la Rosca de Reyes ',
    'place': 'Pachuca de Soto',
    'start': '2025-01-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1876373259664724204"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },

  {
    'id': 236,
    'title': 'Partida de la Rosca de Reyes ',
    'place': 'Pachuca de Soto',
    'start': '2025-01-06',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1876373259664724204"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 237,
    'title': 'Reunión de gabinete ',
    'place': 'Pachuca de Soto',
    'start': '2025-01-07',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1876752163294085386"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 238,
    'title': 'Foro de Desarrollo con Bienestar y Humanismo',
    'place': 'Pachuca de Soto',
    'start': '2025-01-11',
    'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1878186777913045241"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  
{ 
  'id': 239,
  'title': 'Entrega de bicicletas',
  'place': 'Tepeji del Río',
  'start': '2025-01-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1878984243793314260"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 240,
  'title': 'Entrega de bicicletas',
  'place': 'Tizayuca',
  'start': '2025-01-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1879248419044425995"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 241,
  'title': 'Décima sesión para la elaboración del Programa de Ordenamiento Metropolitano del Valle de México.',
  'place': 'Pachuca de Soto',
  'start': '2025-01-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1879248419044425995"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 242,
  'title': 'Reunión de trabajo con el secretario de Gobierno, Guillermo Olivares y representantes de la Oficialía Mayor y la Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible.',
  'place': 'Pachuca de Soto',
  'start': '2025-01-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1880011849124704334"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 243,
  'title': 'Entrega de bicicletas',
  'place': 'Huejutla',
  'start': '2025-01-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1880398438090842459"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 244,
  'title': 'Entrega de bicicletas',
  'place': 'Xochiatipan',
  'start': '2025-01-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1880413041810108723"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 245,
  'title': 'Inicio de construcción de la Casa de la Mujer Indígena',
  'place': 'Atlapexco',
  'start': '2025-01-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1880653291698397625"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 246,
  'title': 'Entrega de bicicletas',
  'place': 'Singuilucan',
  'start': '2025-01-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1881491476368220202"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 247,
  'title': 'Entrega de bicicletas',
  'place': 'Tulancingo y Acaxochitlán',
  'start': '2025-01-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1881542402881814662"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 248,
  'title': 'Entrega de máquinas de coser como parte del programa "Empresa Indígena Comunitaria".',
  'place': 'Tenango de Doria',
  'start': '2025-01-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882058976130662553"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 250,
  'title': 'Entrega de bicicletas',
  'place': 'Santiago de Anaya',
  'start': '2025-01-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882161384554967533"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 251,
  'title': 'Entrega de bordadora industrial como parte del programa "Empresa Indígena Comunitaria".',
  'place': 'Ixmiquilpan',
  'start': '2025-01-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882224070894428635"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 252,
  'title': 'Entrega de bicicletas',
  'place': 'Chapulhuacán ',
  'start': '2025-01-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882476860736696824"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 253,
  'title': 'Toma de compromiso 2025-2026 de Juan José Sierra Álvarez como Presidente Nacional de COPARMEX',
  'place': 'Ciudad de México',
  'start': '2025-01-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882601604911935751"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 254,
  'title': 'Reunión con Víctor Hugo Hofmann, subsecretario de Desarrollo Urbano y Vivienda de la Sedatu. ',
  'place': 'Ciudad de México',
  'start': '2025-01-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882803777901863354"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 255,
  'title': 'Reunión con representantes de la Agencia de Transformación Digital y Telecomunicaciones del Gobierno de México',
  'place': 'Pachuca de Soto',
  'start': '2025-01-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1882930700850266572"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 256,
  'title': 'Proyecto de remodelación del Estadio de Béisbol Corona del Rosal.',
  'place': 'Pachuca de Soto',
  'start': '2025-01-27',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1884048321813307685"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 257,
  'title': 'Tamaliza de la Candelaria',
  'place': 'Pachuca de Soto',
  'start': '2025-01-31',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1885392903708545426"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 258,
  'title': 'Reunión con los enlaces de tecnología de las secretarías y organismos para seguir impulsando la transformación digital en Hidalgo.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1886892135632269584"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 259,
  'title': 'Mesa de trabajo para coordinar acciones ante la emergencia migratoria que afecta a nuestros paisanos en EE.UU.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1887251022541955083"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 260,
  'title': 'Reunión de gabinete. ',
  'place': 'Pachuca de Soto',
  'start': '2025-02-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1887666407917109520"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 261,
  'title': 'Reunión programa de vivienda. ',
  'place': 'Ixmiquilpan',
  'start': '2025-02-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1890146092093939978"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 262,
  'title': 'Reunión con el Excelentísimo Embajador de Pakistán, Shozab Abbas, para dialogar sobre el Geoparque Comarca Minera y las oportunidades de vinculación con su país.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1890556710739222592"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 263,
  'title': 'Entrega de documentación que permitirá a los avecindados, posesionarios y ejidatarios de Batha obtener sus títulos de propiedad.',
  'place': 'Atotonilco de Tula',
  'start': '2025-02-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1891959571687600338"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 264,
  'title': 'Conmemoración de 25 años del Día Internacional de la Lengua Materna.',
  'place': 'San Bartolo Tutotepec',
  'start': '2025-02-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1893026093117931887"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 265,
  'title': 'Reunión simplificación de trámites y servicios.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1893350375056425309?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 266,
  'title': 'Conmemoración del 112° aniversario luctuoso de Francisco I. Madero',
  'place': 'Pachuca de Soto',
  'start': '2025-02-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1893337211413663967?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 267,
  'title': 'Conmemoración del Día de la Bandera.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1894142474072830127?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 268,
  'title': 'Conferencia de prensa para dar los detalles de la carrera "Corre con tu mejor amigo". ',
  'place': 'Pachuca de Soto',
  'start': '2025-02-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/puntoporpuntomx/status/1894522442762051588"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 269,
  'title': 'Carrera: Corre con tu mejor amigo ". ',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-03-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1896265896097968505?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 270,
  'title': 'Reunión de gabinete". ',
  'place': 'Pachuca de Soto',
  'start': '2025-03-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1897670012938207418?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 271,
  'title': 'Sesión del Comité de Planeación para el Desarrollo Regional (COPLADEM)',
  'place': 'Tepeji del Río',
  'start': '2025-03-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1900332626625298658?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 272,
  'title': 'Conferencia matutina en Alfajayucan ',
  'place': 'Alfajayucan',
  'start': '2025-03-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1900630484130161066?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 273,
  'title': 'Arranque de las obras del Tren México–Pachuca.',
  'place': 'Zempoala',
  'start': '2025-03-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1903635647165841854"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 274,
  'title': 'Firma del convenio del Programa de Vivienda para el Bienestar en Hidalgo y la colocación de la primera piedra.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-03-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1903903399898173582"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 275,
  'title': 'Inauguración de la carretera Real del Monte-Huasca.',
  'place': 'Omitlán',
  'start': '2025-03-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1903944626790072711"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{ 
  'id': 276,
  'title': 'Reunión para la actualización del Programa de Ordenamiento Territorial de la Zona Metropolitana del Valle de México.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-04-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1907586201244103054?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 277,
  'title': 'Reunión con ejidatarios sobre el Plan Hídrico y el programa de Tecnificación de Riego.',
  'place': 'Tlahulilpan',
  'start': '2025-04-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1909424983941488848"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 278,
  'title': 'Faena por el Desarrollo',
  'place': 'Huasca',
  'start': '2025-04-08',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1909730578263670958"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 279,
  'title': 'Faena en Mineral del Monte',
  'place': 'Mineral del Monte',
  'start': '2025-04-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1912176648419418159?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 280,
  'title': 'Reunión con presidentes municipales sobre los Planes Municipales de Desarrollo.',
  'place': 'Zapotlán',
  'start': '2025-04-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1915915948516868376"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 281,
  'title': 'Presentación de becas de posgrado que impulsa el Gobierno de Hidalgo. ',
  'place': 'Huejutla',
  'start': '2025-04-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1917794928433762719"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 282,
  'title': 'Celebraciòn del Niño y la Niña',
  'place': 'Huejutla',
  'start': '2025-04-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1918118135107866862"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 283,
  'title': 'Recorrido en Tultitán',
  'place': 'San Felipe Orizatlán',
  'start': '2025-05-01',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1918118135107866862"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 284,
  'title': 'Reuniòn de gabinete',
  'place': 'Pachuca',
  'start': '2025-05-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1919506561484931429"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 285,
  'title': 'Instalaciòn del Comité de Ordenamiento Ecológico de Zapotlán.',
  'place': 'Zapotlána',
  'start': '2025-05-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1919840476770771316"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 286,
  'title': 'Presentación de las becas del Citnova en la Universidad Poltitécnica de Pachuca. ',
  'place': 'Zempoala',
  'start': '2025-05-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1919877535925506371"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 287,
  'title': 'Reuniòn sobre el Plan Nacional Hídrico. ',
  'place': 'Pachuca',
  'start': '2025-05-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1920918601646629116"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 288,
  'title': 'Carrera inaugural del Parque Cultural Hidalguense.',
  'place': 'Pachuca',
  'start': '2025-05-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1921627596372033588"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 289,
  'title': 'Presentación de becas para posgrados en la Universidad Tecnológica del Valle del Mezquital.',
  'place': 'Ixmiquilpan',
  'start': '2025-05-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1922466316235031004"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 290,
  'title': 'Recorrido en El Yathé, con Félix Brambila, titular de Conagua Hidalgo.',
  'place': 'Alfajayucan',
  'start': '2025-05-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1923567916336726279"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 291,
  'title': 'Toma de protesta de la Asociación de Alcaldes de Hidalgo.',
  'place': 'Pachuca',
  'start': '2025-05-19',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1924632964731748548"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 292,
  'title': 'Presentación de las Becas de Posgrados que ofrece Citnova. ',
  'place': 'Tula',
  'start': '2025-05-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1924924182812311859"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 293,
  'title': 'Reunión de trabajo sobre el crecimiento donde estará la estación del Tren México-Querétaro.',
  'place': 'Ciudad de México',
  'start': '2025-05-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1924993384176840726"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 294,
  'title': 'Reunión con representantes de SEDATU, CDMX, Edomex y Morelos para planear cómo deben crecer nuestras ciudades y cómo cuidar mejor el agua que compartimos.',
  'place': 'Pachuca',
  'start': '2025-05-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1925321543967469877"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 295,
  'title': 'Reforestación en Tizayuca',
  'place': 'Tizayuca',
  'start': '2025-05-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1925396117409218562"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 296,
  'title': 'Consulta Ciudadana para la elaboración del Plan Municipal de Desarrollo. ',
  'place': 'Cuautepec',
  'start': '2025-05-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1925746667103437308"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 297,
  'title': 'Conmemoración del Día del Maestro',
  'place': 'Tepej del Río',
  'start': '2025-05-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1926108896302608530"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 298,
  'title': 'En la Unidad de Riego Francisco I. Madero compartió cómo la Tecnificación de riego ayudará a aprovechar mejor el agua y fortalecer el campo.',
  'place': 'Francisco I Madero',
  'start': '2025-05-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1927132524112753053"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 299,
  'title': 'Presentación del del Plan de Justicia',
  'place': 'Pachuca',
  'start': '2025-05-27',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1927538123531022579"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 300,
  'title': 'Reunión con productoras y productores en Chilcuautla para explicar el programa de tecnificación de riego.',
  'place': 'Chilcuautla',
  'start': '2025-05-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1928168998820016624"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 301,
  'title': 'Lunes cívico ',
  'place': 'Pachuca',
  'start': '2025-06-01',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1929614349242716566"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 302,
  'title': 'Reunión  sobre el programa de tecnificación de riego en la Unidad de Riego Tlamaco-Juandhó. ',
  'place': 'Tlahuelilpan',
  'start': '2025-06-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1929715057430233214"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 303,
  'title': 'Reunión con el Secretariado Técnico del Valle de México para seguir construyendo el Programa de Ordenación de la Zona Metropolitana. ',
  'place': 'Ciudad de México',
  'start': '2025-06-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1930683377524576621"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 304,
  'title': 'Reunión de gabinete',
  'place': 'Pachuca',
  'start': '2025-06-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1930796524658676220"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 305,
  'title': 'Reunión con el Director de Infonavit sobre el Programa Nacional de Vivienda. ',
  'place': 'Pachuca',
  'start': '2025-06-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1931133083224588682"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 306,
  'title': 'Reunión con el secretario de Agricultura sobre el  Programa de Tecnificación de Riego en Hidalgo. ',
  'place': 'Atotonilco de Tula',
  'start': '2025-06-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1931495162716299724"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 307,
  'title': 'Entrega de reconocimientos a la primera generación del diplomado “Con Planeación hay Transformación”. ',
  'place': 'Pachuca de Soto',
  'start': '2025-06-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1937996486144340027"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 308,
  'title': 'Conferencia de prensa para la actualización del Plan Estatal de Desarrollo. ',
  'place': 'Pachuca de Soto',
  'start': '2025-06-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1938349665063186859"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 309,
  'title': 'Foro de Consulta Ciudadana para la actualización del Programa Municipal de Desarrollo Urbano de Tlaxcoapan',
  'place': 'Tlaxcoapan',
  'start': '2025-06-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1938429971552247850"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 310,
  'title': 'Como parte del seguimiento al Programa Nacional de Vivienda, se realizó una visita a inmuebles en el municipio de Tepeji del Río.',
  'place': 'Tepeji del Río',
  'start': '2025-06-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1938447048891593001"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 311,
  'title': 'Festival de la Barbacoa del Valle del Mezquital. ',
  'place': 'Ixmiquilpan',
  'start': '2025-06-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/1939429865528102915?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 312,
  'title': 'Reunión con la Secretaria de Hacienda Hidalgo, Esther Ramírez Vargas  para revisar los avances de los proyectos.',
  'place': 'Pachuca de Soto',
  'start': '2025-06-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/Esther_RamirezV/status/1939881340851139058"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 313,
  'title': 'Reunión de revisión de los avances en el Plan Hídrico. ',
  'place': 'Pachuca de Soto',
  'start': '2025-07-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/juliomenchaca_/status/1940585222929879370?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 314,
  'title': 'Presentación del Programa de Compensación Ambiental para la Cuenca del Río Tula. ',
  'place': 'Tula de Allende',
  'start': '2025-07-03',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1940879369360093632?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 315,
  'title': 'Conferencia de prensa para anunciar el Campeonato Nacional Liga Telmex Telcel, con 24 selecciones de béisbol.',
  'place': 'Pachuca de Soto',
  'start': '2025-07-03',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1940931528332341418"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 316,
  'title': 'Feria de la Barbacoa en Actopan',
  'place': 'Actopan',
  'start': '2025-07-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1941304172042912003"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 317,
  'title': 'Reforestaciòn en Santa María Magdalena',
  'place': 'Tepeji del Rio',
  'start': '2025-07-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1941562853825314986"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 318,
  'title': 'COPLADEM en Tepeji del Río',
  'place': 'Tepeji del Rio',
  'start': '2025-07-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1941708285226151992"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 319,
  'title': 'Reunión de gabinete',
  'place': 'Pachuca de Soto',
  'start': '2025-07-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1942423947896672283"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 320,
  'title': 'Padrino de generación de los alumnos del CETiss 26',
  'place': 'Atitalaquia',
  'start': '2025-07-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1943067842691350886"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 321,
  'title': 'Revisión junto al presidente municipal Alfredo González, las obras que se necesitan para que el crecimiento urbano sea ordenado. ',
  'place': 'Tepeapulco',
  'start': '2025-07-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1943446322482237862"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 322,
  'title': 'Reunión con mujeres del sector de la construcción.',
  'place': 'Pachuca de Soto',
  'start': '2025-07-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1943773288146272650?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 323,
  'title': 'Padrino de generación de las niñas y niños de la Primaria “Progreso”.',
  'place': 'El Cardonal',
  'start': '2025-07-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1944061473241681992"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 324,
  'title': 'Banderazo de arranque del nuevo Parque Quetzalcóatl en Tula.',
  'place': 'Tula de Allende',
  'start': '2025-07-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1944836586061095247"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 325,
  'title': 'Padrino de generación de las y los alumnos del  COBAEH Bominthzá',
  'place': 'Tula de Allende',
  'start': '2025-07-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1945227256525197587"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 326,
  'title': 'Supervisión de los avances de la obra del tren Pachuca-AIFA. ',
  'place': 'Villa de Tezontepec',
  'start': '2025-07-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1945831572873069031"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 327,
  'title': 'Reunión de coordinación de acciones con instituciones federales y estatales para el Valle del Mezquital. ',
  'place': 'Pachuca de Soto',
  'start': '2025-07-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1945945564312408302"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 328,
  'title': 'Reunión con las y los presidentes municipales de la región Tula. ',
  'place': 'Tula de Allende',
  'start': '2025-07-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1946026162871803968"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 329,
  'title': 'Participación en el Segmento de Alto Nivel “Alianzas para el Desarrollo Sostenible”.',
  'place': 'Ciudad de México',
  'start': '2025-07-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1946322061753733497"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 330,
  'title': 'Inauguración del Campeonato Nacional de Béisbol Pre Junior.',
  'place': 'Pachuca de Soto',
  'start': '2025-07-19',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1946672631077298635"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 331,
  'title': 'Supervisión de la obra de la Casa de la Mujer Indígena',
  'place': 'Atlapexco',
  'start': '2025-07-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1947459484420395259"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 332,
  'title': 'Reunión con empresarios de la CANACO Servytur Región Tula. ',
  'place': 'Tula de Allende',
  'start': '2025-07-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1947792034388922492"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 333,
  'title': 'Sesión Ordinaria del COPLADEHI',
  'place': 'Pachuca de Soto',
  'start': '2025-07-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1948153427105608123"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 334,
  'title': 'Reunión del Programa de Vivienda para el Bienestar con autoridades municipales y equipos de El Arenal, Huejutla, San Agustín Tlaxiaca, Ixmiquilpan, Tepeapulco, Tepeji del Río, Mineral de la Reforma, Pachuca, Tizayuca, Tolcayuca, Zapotlán, Actopan y Zempoala.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-07-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1948757148252492169"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 335,
  'title': 'Taller de planeación participativa para avanzar en el Programa de Ordenación de la Zona Metropolitana del Valle de México.',
  'place': 'Tula de Allende',
  'start': '2025-07-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1948877441243423163"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 336,
  'title': 'Clausura del Campeonato Nacional de Béisbol',
  'place': 'Pachuca de Soto',
  'start': '2025-07-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1949247055492509989"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 337,
  'title': 'Entrevista en Una Charla con... Sobre los temas del tren, plan hídrico, vivienda y saneamiento.',
  'place': 'Pachuca de Soto',
  'start': '2025-07-28',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1949906934934454637"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 338,
  'title': 'Recorrido de las casas que se están construyendo como parte del Programa Vivienda para el Bienestar.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-07-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1950750605380595917"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 339,
  'title': 'Recorrido en Tolcayuca con el presidente municipal, Armando Zúñiga.',
  'place': 'Tolcayuca',
  'start': '2025-07-31',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1951119422350860388"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 340,
  'title': 'Participación en el foro “La igualdad sustantiva para el Hidalgo que queremos”. ',
  'place': 'Pachuca de Soto.',
  'start': '2025-08-01',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1951416459755741466"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 341,
  'title': 'Reunión con investigadores e investigadoras para impulsar un proyecto de ciencia que, a partir de la economía circular y el talento especializado, pueda generar un impacto.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1952536134569037978"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 342,
  'title': 'Reunión de gabinete.',
  'place': 'Pachuca de Soto.',
  'start': '2025-08-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1952912082967658842"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 343,
  'title': 'Grupo focal con representantes de la Secretaría de Infraestructura.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1953230894111600760"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 344,
  'title': 'Grabación del primer capítulo de La Voz del Pueblo.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1953254223702818965"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 345,
  'title': 'Grupo focal con representantes del sector turístico y la secretaria, Elizabeth Quintanar.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1953640020050403581"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 346,
  'title': 'Reunión con la presidenta municipal de Tepeji del Río,Tania Valdez sobre el tema del agua. ',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1955114491328258395"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 347,
  'title': 'Reunión para la actualización del Programa de Ordenación de la Zona Metropolitana del Valle de México.  ',
  'place': 'Pachuca de Soto',
  'start': '2025-08-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1955748076494246304"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 348,
  'title': 'Demostración las parcelas del Programa Nacional de Tecnificación de Riego.',
  'place': 'Mixquiahuala de Juárez',
  'start': '2025-08-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1956116112749289829"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{ 
  'id': 349,
  'title': 'En San Salvador se dio a conocer el Programa Nacional de Tecnificación de Riego y sus beneficios.',
  'place': 'San Salvador',
  'start': '2025-08-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1956542652830081526"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 350,
  'title': 'Primer Informe de la diputada, Liz Ordaz.',
  'place': 'Pachuca de Soto',
  'start': '2025-08-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1957655877743190523"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 351,
  'title': 'Colocación de la primera piedra del Centro de Abasto Miguel Hidalgo.',
  'place': 'Zapotlán de Juárez',
  'start': '2025-08-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1958708485648261369"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 352,
  'title': 'En la sede de la CEPAL en México represento al Gobierno de Hidalgo, en una mesa de diálogo con especialistas de Argentina, Brasil y México.',
  'place': 'Ciudad de México',
  'start': '2025-08-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1958994665878774032"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 353,
  'title': 'Grabación del podcast La Voz de Hidalgo con tema de Turismo. ',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-08-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1960466561929453603"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 354,
  'title': 'Reunión del Plan Nacional Hídrico',
  'place': 'Pachuca',
  'start': '2025-08-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1960479598875173078"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 355,
  'title': 'Informe de la diputada, Mónica Reyes.',
  'place': 'Tepeapulco',
  'start': '2025-08-27',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1960725859972644896"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 356,
  'title': 'Informe de la diputada, Diana Rangel.',
  'place': 'Progreso de Obregón ',
  'start': '2025-08-27',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1960894552392237502s"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 356,
  'title': 'Tercer Informe de Gobierno',
  'place': 'Huejutla de Reyes',
  'start': '2025-08-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1961540324167135647"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 357,
  'title': 'Tercer Informe de Gobierno',
  'place': 'Tula de Allende',
  'start': '2025-09-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1962993653506572661"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 358,
  'title': 'Grabación del podcast La Voz de Hidalgo',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-03',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1963269656858313189"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 359,
  'title': 'Foro focal de movilidad',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1963758780816204262"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{ 
  'id': 360,
  'title': 'Tercer Informe de Gobierno',
  'place': 'Pachuca de Soto',
  'start': '2025-09-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/juliomenchaca_/status/1964001406823604542"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 361,
  'title': 'Tercer Informe de Gobierno',
  'place': 'Ixmiquilpan',
  'start': '2025-09-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1965531783644283290"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 362,
  'title': '11ª Sesión para la elaboración del Programa de Ordenación de la ZMVM.',
  'place': 'Ciudad de México',
  'start': '2025-09-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1965907667014266971"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 363,
  'title': 'Reunión de gabinete. ',
  'place': 'Pachuca de Soto',
  'start': '2025-09-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1965977356314476617"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 364,
  'title': 'Primer informe del presidente municipal de Pachuca. ',
  'place': 'Pachuca de Soto',
  'start': '2025-09-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1966139261281038677"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 365,
  'title': 'Conferencia Internacional de Gobernanza Metropolitana hacia 2050.',
  'place': 'Ciudad de México',
  'start': '2025-09-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1966273121821856105"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 366,
  'title': 'Reunión con la titular de la SEMARNAT, Alicia Bárcena sobre el proyecto del Parque Ecológico y de Economía Circular. ',
  'place': 'Tula de Allende',
  'start': '2025-09-12',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1966531379249791515"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 367,
  'title': 'Reunión con sociedad civil sobre el proyecto del Parque Ecológico y de Economía Circular. ',
  'place': 'Tlaxcoapan',
  'start': '2025-09-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1966971939458871675"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 368,
  'title': 'Primer informe de la presidenta municipal, Gabriela Escamilla. ',
  'place': 'Chilcuautla. ',
  'start': '2025-09-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1966972880526471213"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 369,
  'title': 'Grupo focal con representantes de Cultura. ',
  'place': 'San Agustín Tlaxiaca ',
  'start': '2025-09-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1967723215234666653"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 370,
  'title': 'Ceremonia de Grito de Independencia',
  'place': 'Pachuca de Soto',
  'start': '2025-09-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1967965421241507911"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 371,
  'title': 'Desfile Cívico y Militar.',
  'place': 'Pachuca de Soto',
  'start': '2025-09-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1968030574528041467"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 372,
  'title': 'Grupo focal con representantes de Sedeco.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1968434951667233112"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 373,
  'title': 'Presentación a ejidatarios del Plan Hídrico',
  'place': 'Tetepango',
  'start': '2025-09-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1968799526757515647"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 374,
  'title': 'Primer informe del presidente municipal, Julio Agustín Tovar.',
  'place': 'Alfajayucan',
  'start': '2025-09-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1969585290559041876"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 375,
  'title': 'Grupo focal con representantes de la Secretaría del Trabajo, trabajadores, empresarios, universidades y profesionistas.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1970333816616108285"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 376,
  'title': 'Entrega de Becas CITNOVA 2025 y el Fondo Hidalgo Ciencia y Tecnología. ',
  'place': 'Pachuca de Soto',
  'start': '2025-09-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1973116185542574301"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 377,
  'title': 'Entrevista con José Luis Rico sobre distintos temas que están marcando la agenda del estado.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1973132382573396333"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 378,
  'title': 'Reunión sobre el Programa de Vivienda para el Bienestar. ',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-09-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1971311470735655053"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 379,
  'title': 'Reunión con autorodades estatales y federales sobre el Plan Nacional Hídrico. ',
  'place': 'Pachuca de Soto',
  'start': '2025-09-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/19732275689974747883"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 380,
  'title': 'Foros de Consulta para la actualización del Plan Estatal de Desarrollo.',
  'place': 'Mineral de la Reforma',
  'start': '2025-10-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1973789855764394385"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 381,
  'title': '3er Informe de Actividades de a Magistrada Presidenta Rebeca Aladro Echeverría. ',
  'place': 'Pachuca de Soto',
  'start': '2025-10-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1973878188213465181"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 382,
  'title': 'Reunión de gabinete',
  'place': 'Pachuca de Soto',
  'start': '2025-10-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1975327087612334227"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 383,
  'title': 'Primer informe de la Senadora, Simey Olvera',
  'place': 'Pachuca de Soto',
  'start': '2025-10-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1975580871538377178"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 384,
  'title': 'Grupo focal del tema de salud.',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-10-07',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1975765554930565126"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 385,
  'title': 'Inauguración del Centro Regional Ambiental Tula-Tepeji y la firma del convenio entre PROFEPA y la UTTT.',
  'place': 'Tula de Allende',
  'start': '2025-10-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1976376321153655022"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 386,
  'title': 'Presentación del Parque de Ecología y Economía Circular. ',
  'place': 'Tlaxcoapan',
  'start': '2025-10-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1976436134831079625"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 387,
  'title': 'Presentación del Parque de Ecología y Economía Circular. ',
  'place': 'Atitalaquia',
  'start': '2025-10-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1976674959192936573"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 388,
  'title': 'Reunión de gabinete donde se presentaron los reportes actualizados de las zonas afectadas por las lluvias para dar seguimiento a las acciones de atención prioritaria.',
  'place': 'Pachuca de Soto',
  'start': '2025-10-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/juliomenchaca_/status/1977194988036669600"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 389,
  'title': 'Reparto de víveres y agua en la sierra gorda.',
  'place': 'Sierra Gorda',
  'start': '2025-10-12',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1977543897548292191"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 390,
  'title': 'En Tepehuacán y Chapulhuacán, apoyando a las familias afectadas por las lluvias.',
  'place': 'Tepehuacán y Chapulhuacán',
  'start': '2025-10-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1977819064170111348"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 391,
  'title': 'Entrega de víveres, agua y herramientas a las comunidades afectadas. ',
  'place': 'Chapulhuacán',
  'start': '2025-10-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1977840643176313038"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 392,
  'title': 'Entrega de víveres y herramientas en la comunidad de Santiago. ',
  'place': 'Tlahuiltepa',
  'start': '2025-10-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1979319311178277068"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 393,
  'title': 'Entrega de víveres y artículos de limpieza en la comunidad Cerro del Águila.',
  'place': 'Tlahuiltepa',
  'start': '2025-10-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1979322147123401082"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 394,
  'title': 'Seguimiento a las familias afectadas por las lluvias en San Andrés Miraflores.',
  'place': 'Tlahuiltepa',
  'start': '2025-10-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1981174777470456069"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 395,
  'title': 'En Itztamichapa entrega de víveres, agua y herramientas para seguir fortaleciendo a la comunidad.',
  'place': 'Tlahuiltepa',
  'start': '2025-10-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1981197514385526805"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 396,
  'title': 'Foro de consulta para actualizar el Plan Estatal de Desarrollo 2025–2028.',
  'place': 'Tula',
  'start': '2025-10-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1981838230006923323"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 397,
  'title': 'Foro de consulta para actualizar el Plan Estatal de Desarrollo 2025–2028.',
  'place': 'Tizayuca',
  'start': '2025-10-28',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1983275886716874936"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 398,
  'title': 'Reunión de gabinete. ',
  'place': 'Pachuca de Soto',
  'start': '2025-11-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1985803405307392022?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 399,
  'title': 'Entrega de apoyos en las zonas afectadas por las recientes lluvias. ',
  'place': 'Juárez Hidalgo',
  'start': '2025-11-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1986180609589260630?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 400,
  'title': 'Foros regionales para actualizar el Plan Estatal de Desarrollo.',
  'place': 'Huichapan',
  'start': '2025-11-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1988388468184281326?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 401,
  'title': 'Foros regionales para actualizar el Plan Estatal de Desarrollo.',
  'place': 'Apan',
  'start': '2025-11-12',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1988763284816777573?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 402,
  'title': 'Entrega de apoyos a los afectados por  inundaciones.',
  'place': 'Chapulhuacán de Guerrero',
  'start': '2025-11-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1989041577885593988?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 403,
  'title': 'Presentación del plan de trabajo y avance del Plan Integral de Movilidad Urbana Sustentable.  ',
  'place': 'Tizayuca',
  'start': '2025-11-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/MovilidadHgo/status/1989411781916471619?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 404,
  'title': 'Foro Regional',
  'place': 'Zacualtipán',
  'start': '2025-11-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1990915420082012501?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 405,
  'title': 'Comparecencia ',
  'place': 'Pachuca de Soto',
  'start': '2025-11-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1991267804343869731?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 406,
  'title': 'Entrega de apoyos  y  arranque de la Casa de la Mujer Indígena. ',
  'place': 'Tenango de Doria',
  'start': '2025-12-02',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1996055806291100038?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 407,
  'title': 'Entrega de distintos programas. ',
  'place': 'Tianguistengo',
  'start': '2025-12-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1996696984669855889?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 408,
  'title': 'Entrega de apoyos ',
  'place': 'Molango',
  'start': '2025-12-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1996760221482443101?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 409,
  'title': 'Sesión del Comité Estatal de Información Estadística y Geografía',
  'place': 'Pachuca de Soto',
  'start': '2025-12-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1997038280806646087?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 410,
  'title': 'Reunión de gabinete',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-12-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1997143744202575986?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 411,
  'title': 'Entrega del Guardianas de Vida ',
  'place': 'Atlapexco',
  'start': '2025-12-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1998381057658224777?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 412,
  'title': 'Reunión del Plan Hídrico Estatal',
  'place': 'Pachuca de Soto',
  'start': '2025-12-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/1998862320072892521?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 413,
  'title': 'Sesión del COPLADEM',
  'place': 'Atitalaquia',
  'start': '2025-12-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2000742827567780296?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 414,
  'title': ' Reunión con representantes de SEDATU y de los gobiernos de CDMX, Estado de México y Morelos. ',
  'place': 'San Agustín Tlaxiaca',
  'start': '2025-12-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2001421360187183469?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 415,
  'title': 'Seguimiento de acciones por las lluvias atípicas. ',
  'place': 'Pacula',
  'start': '2025-12-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2001754706998116433?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 416,
  'title': 'Reunión de gabinete.',
  'place': 'Pachuca de Soto',
  'start': '2026-01-12',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2010893365928222944?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 417,
  'title': 'Inauguración del Parque Quetzalcóatl.',
  'place': 'Tula',
  'start': '2026-01-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2011866325027541010?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 418,
  'title': 'Primera Sesión Ordinaria 2026 del Secretariado Técnico Conjunto de la ZMVM. ',
  'place': 'Toluca',
  'start': '2026-01-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2014096241404076208?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 419,
  'title': 'Reunión con Yocelyn Tovar Presidenta Municipal de Atotonilco de Tula ',
  'place': 'Atotonilco de Tula',
  'start': '2026-01-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2015110784641081601?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 420,
  'title': 'Reunión de gabinete ',
  'place': 'Pachuca de Soto',
  'start': '2026-02-04',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2019217239854199119?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 421,
  'title': 'En conferencia de prensa habló de cómo la planeación transforma esto en empleos, inversión y futuro real.',
  'place': 'Pachuca de Soto',
  'start': '2026-02-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2020947680118059105?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 422,
  'title': 'Sesión de Copladem',
  'place': 'Tepeji del Río',
  'start': '2026-02-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2021066210683617320?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 423,
  'title': 'Encuentro con vecinas, vecinos, niñas y niños de Atotonilco de Tula para escuchar sus ideas y comenzar a construir juntos, a través del esquema de diseño participativo la nueva Unidad Deportiva.',
  'place': 'Atotonilco de Tula',
  'start': '2026-02-11',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2021749464830992453?s=46&t=xrFyHEi1ZAvl81nUx2L5vQ"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 424,
  'title': 'Reunión con pobladores de Ixmiquilpan para explicar el funcionamiento del Programa de Vivienda para el Bienestar',
  'place': 'Ixmiquilpan',
  'start': '2026-03-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2029643461612482901?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 425,
  'title': 'Bacheo en El Tablón, Atitalaquia, con la presidenta Claudia Sandoval y los vecinos y vecinas.',
  'place': 'Atitalaquia, Hidalgo',
  'start': '2026-03-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2035389287651303509?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 426,
  'title': 'En conferencia de prensa presentó la actualización del Plan Estatal de Desarrollo y el PIMUS para la Zona Metropolitana de Pachuca.',
  'place': 'Pachuca de Soto',
  'start': '2026-03-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2036134764416053566?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 427,
  'title': 'Visitó el Instituto Nacional de Investigaciones Forestales, Agrícolas y Pecuarias para conocer de cerca cómo la investigación aplicada puede incidir directamente en el sector productivo.',
  'place': 'Celaya, Guanajuato',
  'start': '2026-03-26',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2037330053915152497?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 428,
  'title': 'Bacheo con la Presidenta Municipal Yocelyn Tovar y participación ciudadana.',
  'place': 'Atotonilco de Tula',
  'start': '2026-03-28',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2038011381690126444?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 429,
  'title': 'Sesión del Comité de Planeación para el Desarrollo Municipal',
  'place': 'Tezontepec de Aldama',
  'start': '2026-03-30',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2038711615852552308?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 430,
  'title': 'Reunión mensual de gabinete.',
  'place': 'Pachuca de Soto',
  'start': '2026-04-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2041252988841308278?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 431,
  'title': 'Plática con alumnos del Tecnológico de Monterrey campus Hidalgo sobre experiencia en la administración pública en este gobierno.',
  'place': 'Pachuca de Soto',
  'start': '2026-04-09',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2042315084068724968?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 432,
  'title': 'Mejores traslados, servicios más cercanos y ciudades mejor planificadas. En eso estamos trabajando para Hidalgo. Junto con @SEDATU_mx,@Edomex,@GobCDMX, y @GobiernoMorelos, celebramos una sesión de trabajo para coordinar acciones para organizar el crecimiento de #ZMVM .',
  'place': 'Pachuca de Soto',
  'start': '2026-04-10',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/https://x.com/mtellov/status/2042722024074940537?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 433,
  'title': 'Consulta pública del Programa Parcial de Desarrollo Urbano de Pachuca–Mineral de la Reforma',
  'place': 'Pachuca de Soto - Tecnológico de Monterrey Campus Hidalgo',
  'start': '2026-04-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2043768961100083352?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 434,
  'title': 'Exposición colectiva “Intervención Gráfica 4.1 HIÓKI: Acto de Reconstrucción”.',
  'place': 'Pachuca de Soto',
  'start': '2026-04-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2044170255379976528?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 435,
  'title': 'En la Sesión Ordinaria de la COPLADEM en Nopala de Villagrán, junto a la presidenta municipal, Diana Moreno, pudimos constatar la presencia de la voz del pueblo en cada decisión, con transparencia y rendición de cuentas. Asimismo, revisamos el avance del Plan de Desarrollo Municipal.',
  'place': 'Nopala de Villagran',
  'start': '2026-04-17',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2045273099306762504?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 436,
  'title': 'Presentación de Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en la UPT de Tulancingo',
  'place': 'Tulancingo de Bravo, Hidalgo',
  'start': '2026-04-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2046353070796222744?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 437,
  'title': 'Presentación de Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en el ITS Huichapan',
  'place': 'Huichapan, Hidalgo',
  'start': '2026-04-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2046768521862881724?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 438,
  'title': 'Reunión en Conagua para trabajar en equipo los proyectos hidricos del programa Vivienda para el Bienestar en Hidalgo',
  'place': 'Ciudad de México',
  'start': '2026-04-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2047084576388882605?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 439,
  'title': 'Reunión de Trabajo en la Comisión de Desarrollo Metropolitano del Valle de México',
  'place': 'Estado de México',
  'start': '2026-04-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2047155414370762827?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 440,
  'title': 'Presentación de Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en el Tecnológico Nacional de México Campus Occidente del Estado de Hidalgo',
  'place': 'Mixquiahuala',
  'start': '2026-04-23',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2047435270115500316?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 441,
  'title': 'Reunión con productores de granada de la región de Chilcuautla que forman parte de las NODESS (Nodos de Economía Social y Solidaria)',
  'place': 'Chilcuautla',
  'start': '2026-04-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2047678216207323446?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 442,
  'title': ' Festejemos a las Niñas y los Niños de Hidalgo 2026.',
  'place': 'Pachuca de Soto',
  'start': '2026-04-24',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2047800275654914181?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 443,
  'title': 'Reunión de trabajo con el Delegado y comisariado de Panale',
  'place': 'Ixmiquilpan',
  'start': '2026-04-27',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2048914318658552087?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 444,
  'title': 'Presentación de Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en el ITS Tula de Allende',
  'place': 'Tula de Allende',
  'start': '2026-04-28',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2049274753349734908?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 445,
  'title': 'Reunión con el presidente municipal de Zempoala, Francisco Sinuhé Ramírez',
  'place': 'Zempoala',
  'start': '2026-04-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2049517540372517015?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 446,
  'title': 'Entrega de reconocimientos a niñas, niños y jóvenes ganadores nacionales e internacionales de ExpoCiencias',
  'place': 'Pachuca de Soto - Congreso de Hidalgo',
  'start': '2026-04-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2049545608973734195?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 447,
  'title': 'Reunión mensual de gabinete',
  'place': 'Pachuca de Soto',
  'start': '2026-05-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2051774635776090517?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 448,
  'title': 'Entrega con el Gobernador de unidades por parte de Pemex para fortalecer los servicios públicos y mejorar la capacidad de atención en los municipios de Hidalgo.',
  'place': 'Zapotlán',
  'start': '2026-05-06',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2052158227698106822?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 449,
  'title': 'Primera Sesión Ordinaria 2026 del Comité Estatal de Información Estadística y Geográfica de Hidalgo',
  'place': 'Pachuca de Soto',
  'start': '2026-05-08',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2052860315201593706?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 450,
  'title': 'Sesión de COPLADEM en Tepeji del Río',
  'place': 'Tepeji del Río',
  'start': '2026-05-12',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2054406636656005169?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 451,
  'title': 'Entrega de bicicletas como parte del Bicicletón Indígena',
  'place': 'Tepeji del Río',
  'start': '2026-05-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2054350580949115077?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 452,
  'title': 'Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en el Instituto de Ciencias Sociales y Humanidades',
  'place': 'Pachuca de Soto',
  'start': '2026-05-13',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2054663788050153890?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 453,
  'title': 'Recorrido en el Parque El Chamizal',
  'place': 'Tula de Allende',
  'start': '2026-05-14',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2055088086112248250?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 454,
  'title': 'Reunión con productores agrícolas, Kilimo y La Costeña',
  'place': 'Apan',
  'start': '2026-05-15',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2055416638053212558?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 455,
  'title': 'Evento "La Truchiza" ',
  'place': 'Mineral del Chico',
  'start': '2026-05-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2055777430472704136?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 456,
  'title': 'Conferencia de Prensa',
  'place': 'Pachuca de Soto',
  'start': '2026-05-18',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2056437581013754022?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 457,
  'title': 'Becas de Posgrado y Fondo Hidalgo, Ciencia y Tecnología, Impulso al Desarrollo Científico, Humanidades, e Innovación Social con Base Tecnológica en el Instituto de Ciencias Sociales y Humanidades',
  'place': 'Apan',
  'start': '2026-05-19',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2056864291333210327?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 458,
  'title': 'Reunión para informar sobre obras de protección y recuperación de espacio público en el Río Tula',
  'place': 'Tula de Allende',
  'start': '2026-05-21',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2057644618905190740?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 459,
  'title': 'En el marco de la actualización del Programa de Ordenación de la Zona Metropolitana del Valle de México, la SEDATU presentó los avances de la consulta pública e indígena.',
  'place': 'Ciudad de México ',
  'start': '2026-05-22',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2057922123847410172?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 460,
  'title': 'Campaña "A ver … a ver" ',
  'place': 'Huichapan',
  'start': '2026-05-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2059028137196056705?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 461,
  'title': 'Inauguración de obra en la Primaria Emiliano Zapata de Llano Largo',
  'place': 'Huichapan',
  'start': '2026-05-25',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2059062726710714723?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 462,
  'title': 'Sesión Ordinaria COPLADEM',
  'place': 'neral del Chico',
  'start': '2026-05-29',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2060450310649241850?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 463,
  'title': 'Foro de Consulta Ciudadana del Programa Municipal de Desarrollo Urbano',
  'place': 'Singuilucan',
  'start': '2026-06-01',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2061529746110926862?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 464,
  'title': 'Firma de Convenio con la SEDATU',
  'place': 'San Agustin Tlaxiaca',
  'start': '2026-06-01',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2061602799679353101?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 465,
  'title': 'Sesión Ordinaria COPLADEM',
  'place': 'Tizayuca',
  'start': '2026-06-03',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2062218676011495911?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 466,
  'title': 'Semana de la Evaluación Glocal',
  'place': 'Pachuca de Soto',
  'start': '2026-06-03',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2062291983625072686?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 467,
  'title': 'Reunión mensual de Gabinete',
  'place': 'Pachuca de Soto',
  'start': '2026-06-05',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2063084848105881912?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 468,
  'title': 'Sesión del COPLADEM',
  'place': 'Zapotlan,',
  'start': '2026-06-16',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2067003066742620618?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 469,
  'title': 'Inauguración de la Ciudad Deportiva de Alto Rendimiento',
  'place': 'Pachuca de Soto',
  'start': '2026-06-20',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/mtellov/status/2068411230226952652?s=20"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 47,
  'title': '',
  'place': '',
  'start': '2026-06-',
  'color': 'var(--wine)',
  'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"><a href=https://twitter.com/"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
}
   
   
    

];
